import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from '../ui/Button';
const LOGO_URL = 'https://www.apc360zone.com/uploaded%2Fimages%2FRedesigne%202024%2FMTDLarge%201.png';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const navLinks = [{
    name: 'About Us',
    href: '/about-apc'
  }, {
    name: 'Law Enforcement',
    href: '/law-enforcement-capabilities'
  }, {
    name: 'Civilian',
    href: '/civilian-protection'
  }, {
    name: 'Corporate',
    href: '/corporate-critical-incidents-planning'
  }, {
    name: 'Training',
    href: '/training'
  }, {
    name: 'Resources',
    href: '/strategic-partners'
  }, {
    name: 'Blog',
    href: '/blog'
  }];
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-brand-black/90 backdrop-blur-md border-b border-brand-gray-800" data-id="element-41">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-42">
        <div className="flex justify-between items-center h-20" data-id="element-43">
          {/* Logo */}
          <a href="/" className="flex-shrink-0" data-id="element-44">
            <img src={LOGO_URL} alt="Medina Tactical Dynamics" className="h-14 w-auto" data-id="element-45" />
          </a>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center space-x-8" data-id="element-46">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-brand-gray-300 hover:text-brand-teal uppercase tracking-wider transition-colors" data-id="element-47">
                {link.name}
              </a>)}
            <Button href="/Contact-Medina Tactical" variant="primary" size="sm" data-id="element-48">
              Contact Us
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden flex items-center" data-id="element-49">
            <button onClick={() => setIsOpen(!isOpen)} className="text-brand-gray-300 hover:text-brand-white focus:outline-none" data-id="element-50">
              {isOpen ? <X className="h-6 w-6" data-id="element-51" /> : <Menu className="h-6 w-6" data-id="element-52" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      {isOpen && <div className="lg:hidden bg-brand-gray-900 border-b border-brand-gray-800" data-id="element-53">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-54">
            {navLinks.map(link => <a key={link.name} href={link.href} className="block px-3 py-2 text-base font-medium text-brand-gray-300 hover:text-brand-teal hover:bg-brand-gray-800 uppercase tracking-wider" data-id="element-55">
                {link.name}
              </a>)}
            <div className="px-3 py-2" data-id="element-56">
              <Button href="/Contact-Medina Tactical" variant="primary" className="w-full" data-id="element-57">
                Contact Us
              </Button>
            </div>
          </div>
        </div>}
    </nav>;
}